module.exports = __webpack_public_path__ + "assets/img/28985.png?6c8bb8ad4b329b52c04272ab580f3cee";